import { useState, useEffect, useRef } from "react";
import InputIconSearchPanel from "../components/InputIconSearchPanel";
import InputIconSearchPanelMultiSelection from "../components/InputIconSearchPanelMultiSelection";
import Tag from "../components/Tag";
import HearingAidsFamily from "../components/HearingAidsFamily";
import LensesFamily from "../components/LensesFamily";
import ContactLensesFamily from "../components/ContactLensesFamily";
import LiquidsFamily from "../components/LiquidsFamily";
import FramesFamily from "../components/FramesFamily";
import VariousFamily from "../components/VariousFamily";
import SunglassesFamily from "../components/SunglassesFamily";
import CheckBox from "../components/CheckBox";
import InputIconSearch from "../components/InputIconSearch";
import ButtonIconV from "../components/ButtonIconV";
import SupplierCardLite from "../components/SupplierCardLite";
import {
  focusElement,
  selectedOptic,
  supplierStructure,
  userData,
  inputOnEnter,
  LIMIT,
  formatValueUnit,
  hearingAidsStoreTableHeader,
  lensesStoreTableHeader,
  contactLensesStoreTableHeader,
  liquidsStoreTableHeader,
  framesStoreTableHeader,
  variousStoreTableHeader,
  sunglassesStoreTableHeader,
} from "../js/utils";
import { post } from "../js/post";
import { download } from "../js/post";
import "../css/Store.css";
import ButtonIconH from "../components/ButtonIconH";
import { useSuppliers } from "../hooks/useSuppliers";
import { useBrands } from "../hooks/useBrands";
import { ExportOrSendPopup } from "../components/ExportOrSendPopup";
import LoadingScreen from "../components/LoadingScreen";
import PopupMessage from "../components/PopupMessage";
import { StockTransfer } from "../components/StockTransfer";
import { Inventory } from "../components/Inventory";
import moment from "moment";

export default function Store(props) {
  const [currentSupplier, setCurrentSupplier] = useState(supplierStructure);
  const [selectedTab, setSelectedTab] = useState("");
  const [inputCode, setInputCode] = useState("");
  const [inputSupplier, setInputSupplier] = useState("");
  const [inputProduct, setInputProduct] = useState("");
  const [positiveStock, setPositiveStock] = useState(true);
  const [discontinued, setDiscontinued] = useState(false);
  const [supplierList, refreshSuppliers] = useSuppliers(
    selectedTab,
    inputSupplier,
  );
  const [supplierListFiltered, setSupplierListFiltered] =
    useState(supplierList);
  const [brandList, refreshBrands] = useBrands(
    selectedTab,
    currentSupplier ? currentSupplier.id : -1,
    "",
  );
  const [selectedBrandList, setSelectedBrandList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productListFiltered, setProductListFiltered] = useState([]);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [limit, setLimit] = useState(LIMIT);
  const [totalProds, setTotalProds] = useState(0);
  const menuRef = useRef(null);
  const [exportOrSendPopup, setExportOrSendPopup] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [sendingEmailMessage, setSendingEmailMessage] = useState("");
  const [sendingEmailMessageDef, setSendingEmailMessageDef] = useState("");
  const [exportOrSendFileData, setExportOrSendFileData] = useState({
    type: 0,
    mail: "",
  });
  const [toggleTransfer, setToggleTransfer] = useState(false);
  const [toggleInventory, setToggleInventory] = useState(false);

  // console.log("productList: ", productList);
  // console.log("productListFiltered: ", productListFiltered);
  // console.log("currentSupplier: ", currentSupplier);

  let tabs = [
    {
      label: "Audífonos",
      content: (
        <HearingAidsFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={async (limit) => {
            setLimit(limit);
            // console.log("ENTRA 3");
            await getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            // console.log("ENTRA 4");
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 0
          ? "/images/preferenciaAudifonos-white.svg"
          : "/images/preferenciaAudifonos.svg",
    },
    {
      label: "Lentes",
      content: (
        <LensesFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 1
          ? "/images/accommodative-white.svg"
          : "/images/accommodative-blue.svg",
    },
    {
      label: "L. Contacto",
      content: (
        <ContactLensesFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 2
          ? "/images/preferenciaLentillas-white.svg"
          : "/images/preferenciaLentillas.svg",
    },
    {
      label: "Líquidos",
      content: (
        <LiquidsFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 3
          ? "/images/preferenciaLiquido-white.svg"
          : "/images/preferenciaLiquido.svg",
    },
    {
      label: "Monturas",
      content: (
        <FramesFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 4
          ? "/images/preferenciaGafasGraduadas-white.svg"
          : "/images/preferenciaGafasGraduadas.svg",
    },
    {
      label: "Varios",
      content: (
        <VariousFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 5
          ? "/images/preferenciaVarios-white.svg"
          : "/images/preferenciaVarios.svg",
    },
    {
      label: "Sol",
      content: (
        <SunglassesFamily
          products={productListFiltered}
          openProductPanel={async (code) => {
            props.openProductPanel(selectedTab, code, () => {});
          }}
          onSelectedProducts={handleSelectProducts}
          onSeeMore={(limit) => {
            setLimit(limit);
            getProducts(productListFiltered.length, limit, true);
          }}
          onHandleLimit={async (limit) => {
            setLimit(limit);
            await getProducts(0, limit, false);
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      ),
      icon:
        selectedTab === 6
          ? "/images/preferenciaGafasDeSol-white.svg"
          : "/images/preferenciaGafasDeSol.svg",
    },
  ];

  function handleSelectProducts(products) {
    setSelectedProductList(products);
  }

  const getProducts = async (from, total, add) => {
    if (selectedTab !== "") {
      const response = await post("ListarProductos.php", {
        token: userData.token,
        familia: selectedTab,
        idProveedor: currentSupplier.id !== -1 ? currentSupplier.id : -1,
        marcas: selectedBrandList,
        inputFiltro: inputProduct,
        idOptica: selectedOptic.id,
        categoria: "",
        fechaDesdeUltimaCompra: startDate,
        fechaHastaUltimaCompra: endDate,
        stockPositivo: positiveStock,
        descatalogados: discontinued,
        start: from,
        total,
      });
      // console.log(
        // ">> LISTANDO PRODUCTOS: ",
        // {
          // token: userData.token,
          // familia: selectedTab,
          // idProveedor: currentSupplier.id !== -1 ? currentSupplier.id : -1,
          // marcas: selectedBrandList,
          // inputFiltro: inputProduct,
          // idOptica: selectedOptic.id,
          // categoria: "",
          // fechaDesdeUltimaCompra: startDate,
          // fechaHastaUltimaCompra: endDate,
          // stockPositivo: positiveStock,
          // descatalogados: discontinued,
          // start: from,
          // total,
        // },
        // response,
      // );
      setTotalProds(response.totalProductos);
      if (add) {
        setProductList((prev) => [...prev, ...response.productos]);
      } else setProductList(response.productos);
    }
  };

  async function searchProduct() {
    if (inputCode !== "") {
      const response = await post("BuscarProducto.php", {
        token: userData.token,
        input: inputCode,
      });
      if (response.codigoOPTIWIN !== "") {
        props.openProductPanel(
          response.codigoOPTIWIN[0],
          response.codigoOPTIWIN,
          () => {},
        );
      } else {
        props.createPopupQuestion(
          `No se ha encontrado ningún producto.`,
          props.removePopupQuestion,
          null,
          "Aceptar",
        );
      }
    }
  }

  function checkSelectedBrands() {
    if (selectedBrandList.length > 0) {
      const aux = selectedBrandList.filter((brand) =>
        brandList.includes(brand),
      );
      setSelectedBrandList(aux);
    }
  }

  async function clearSupplierAndBrands() {
    setCurrentSupplier(supplierStructure);
    setInputSupplier("");
    setSelectedBrandList([]);
    setStartDate("");
    setEndDate("");
    setInputProduct("");
    setPositiveStock(true);
    setDiscontinued(false);
    setStartDate("");
    setEndDate("");
  }

  const validateDate = (e, op) => {
    const dateValue = e.target.value;
    const year = new Date(dateValue).getFullYear();

    if (year < 1900) {
      switch (op) {
        case 0:
          setStartDate("");
          focusElement(7);
          break;
        case 1:
          setEndDate("");
          focusElement(8);
          break;
        default:
          break;
      }
      return;
    }
  };

  const getFamilyName = () => {
    const names = {
      0: "Audífonos",
      1: "Lentes",
      2: "Lentes de contacto",
      3: "Líquidos",
      4: "Monturas",
      5: "Varios",
      6: "Sol",
    };
    return names[selectedTab];
  };

  const getFamilyTableHeader = () => {
    const headers = {
      0: hearingAidsStoreTableHeader,
      1: lensesStoreTableHeader,
      2: contactLensesStoreTableHeader,
      3: liquidsStoreTableHeader,
      4: framesStoreTableHeader,
      5: variousStoreTableHeader,
      6: sunglassesStoreTableHeader,
    };
    return headers[selectedTab];
  };

  const formatDate = (date) =>
    date && moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "";

  const getFamilyTableValues = () => {
    const map = (fields) =>
      productListFiltered.map((e) => [
        e.codigo,
        formatDate(e.fechaUltimaCompra),
        ...fields(e),
        formatValueUnit(e.PVP, "€"),
        formatValueUnit(e.stock),
      ]);

    switch (selectedTab) {
      case 0:
        return map((e) => [e.modelo, e.tipo, e.entreDB, e.hastaDB]);
      case 1:
        return map((e) => [
          e.nombreComercial,
          e.color,
          e.tratamiento,
          e.ind,
          e.esf,
          e.cil,
          e.eje,
          e.material,
          e.tipo,
        ]);
      case 2:
        return map((e) => [
          e.nombreComercial,
          e.tipo,
          e.uso,
          e.color,
          e.esf,
          e.cil,
          e.eje,
          e.rad,
          e.rad2,
          e.diam,
        ]);
      case 3:
        return map((e) => [
          e.marca,
          e.nombreComercial,
          formatValueUnit(e.capacidad),
        ]);
      case 4:
        return map((e) => [
          e.marca,
          e.modelo,
          e.color,
          e.calibre,
          e.puente,
          e.varilla,
          e.material,
          e.forma,
        ]);
      case 5:
        return map((e) => [e.marca, e.producto, e.categoria]);
      case 6:
        return map((e) => [
          e.marca,
          e.modelo,
          e.colorMontura,
          e.colorCristal,
          e.calibre,
          e.puente,
          e.varilla,
          e.material,
          e.forma,
        ]);
      default:
        return [];
    }
  };

  async function exportFile(type, email, table) {
    const exportDatAux = {
      token: userData.token,
      tipo: type === 0 ? "pdf" : type === 1 ? "excel" : type === 2 ? "csv" : "",
      email: email,
      idOpticaEmail: email === "" ? "" : selectedOptic.id,
      tabla: table,
    };
    setSendingEmailMessageDef(
      <LoadingScreen
        message={email === "" ? "Generando archivo..." : "Enviando archivo..."}
      ></LoadingScreen>,
    );
    setSendingEmail(true);
    const response = await download("ImprimirTabla.php", exportDatAux);
    if (response.error !== "") {
      setSendingEmailMessage(response.error);
    } else {
      setSendingEmailMessage("El email se ha enviado correctamente.");
      setSendingEmail(false);
    }
  }

  useEffect(() => {
    // console.log("ENTRA 1");
    getProducts(0, limit, false);
  }, [
    currentSupplier,
    selectedBrandList,
    startDate,
    endDate,
    positiveStock,
    discontinued,
    props.closeProductPanel,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getProducts(0, limit, false);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputProduct]);

  useEffect(() => {
    refreshSuppliers(selectedTab, inputSupplier);
  }, [props.closeSuppliersPanel]);

  useEffect(() => {
    if (selectedTab !== "") {
      // console.log("ENTRA EN MARCAS: ", selectedTab, currentSupplier);
      refreshBrands(currentSupplier.id);
    }
  }, [props.closeProductPanel]);

  useEffect(() => {
    if (props.show) {
      focusElement(1);
    }
  }, [props]);

  useEffect(() => {
    if (inputSupplier === "") {
      setSupplierListFiltered(supplierList);
    } else {
      setSupplierListFiltered(
        supplierList.filter((supplier) =>
          supplier.nombre.includes(inputSupplier),
        ),
      );
    }
  }, [inputSupplier, supplierList]);

  useEffect(() => {
    setProductListFiltered(
      productList.filter((product) => {
        const stockCondition = positiveStock
          ? product.stock > 0 || product.sinControlStock
          : true;
        const discontinuedCondition = discontinued
          ? true
          : !product.descatalogado;
        return stockCondition && discontinuedCondition;
      }),
    );
  }, [discontinued, positiveStock, productList]);

  useEffect(() => {
    setSelectedProductList((prev) =>
      prev.filter((e) => productListFiltered.some((p) => p.id === e.id)),
    );
  }, [productListFiltered]);

  useEffect(() => {
    checkSelectedBrands();
  }, [brandList]);

  useEffect(() => {
    if (!props.updatedBEProductList || props.updatedBEProductList.length === 0)
      return;
    setProductList((prev) =>
      prev.map((product) => {
        const updated = props.updatedBEProductList.find(
          (p) => p.id === product.id,
        );
        return updated ? updated : product;
      }),
    );
  }, [props.updatedBEProductList]);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">Almacén</span>
        <div className="patient-header-buttons"></div>
      </div>
      {sendingEmail && (
        <PopupMessage
          text={
            sendingEmailMessage === ""
              ? sendingEmailMessageDef
              : sendingEmailMessage
          }
          textAccept={sendingEmailMessage === "" ? null : "Entendido"}
          onClickAccept={
            sendingEmailMessage === ""
              ? null
              : () => {
                  setSendingEmailMessage("");
                  setSendingEmailMessageDef("");
                  setSendingEmail(false);
                }
          }
        ></PopupMessage>
      )}
      {exportOrSendPopup && (
        <ExportOrSendPopup
          onClose={() => {
            setExportOrSendPopup(false);
          }}
          onChange={(type, mail) => {
            setExportOrSendFileData({ type: type, mail: mail });
          }}
          onExport={async () => {
            const table = {
              tituloInforme: `Almacén - ${getFamilyName()}`,
              tabla: {
                cabecera: getFamilyTableHeader(),
                filas: getFamilyTableValues(),
              },
            };
            await exportFile(
              exportOrSendFileData.type,
              exportOrSendFileData.mail,
              table,
            );
          }}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
        />
      )}
      {toggleTransfer && (
        <StockTransfer
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          onClose={() => {
            setToggleTransfer(false);
          }}
        />
      )}
      {toggleInventory && (
        <Inventory
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          onClose={() => {
            setToggleInventory(false);
          }}
        />
      )}
      <div className="patient-data-content store-data-content">
        <div className="action-bar action-bar-store">
          <div className="action-bar-resume">
            <span className="signed-text">Almacén</span>
          </div>
        </div>
        <div
          className="store-info"
          style={{ display: "flex", flexDirection: "row", height: "124px" }}
        >
          <div className="patient-search-content store-search-content">
            <div className="opt-table-title">Búsqueda de producto</div>
            <div className="data-field">
              <span className="label">Familia + Código/EAN/UPC/REF</span>
              <InputIconSearch
                tabIndex={1}
                type="type-alphanum-ext"
                size={3}
                input={inputCode}
                onChange={(e) => {
                  setInputCode(e);
                }}
                onClear={() => {
                  setInputCode("");
                }}
                onEnter={async () => {
                  await searchProduct();
                }}
              ></InputIconSearch>
            </div>
          </div>
          <div className="patient-search-content store-search-content custom-w">
            <div className="opt-table-title">Opciones producto</div>
            <div
              className="data-field"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                }}
              >
                <ButtonIconH
                  text="Traspasos"
                  small={true}
                  highlight={true}
                  onClick={() => {
                    setToggleTransfer(true);
                  }}
                ></ButtonIconH>
                <ButtonIconH
                  text="Inventario"
                  small={true}
                  highlight={true}
                  onClick={() => {
                    setToggleInventory(true);
                  }}
                ></ButtonIconH>
                <ButtonIconH
                  text="Nuevo producto"
                  disabled={selectedTab === "" || currentSupplier.id === -1}
                  small={true}
                  highlight={true}
                  onClick={() => {
                    if (selectedTab !== "" && currentSupplier.id !== -1) {
                      props.openProductPanel(
                        selectedTab,
                        -1,
                        () => {},
                        currentSupplier.id,
                        selectedBrandList,
                      );
                    }
                  }}
                ></ButtonIconH>
              </div>
              {(selectedTab === "" || currentSupplier.id === -1) && (
                <span className="info-text">
                  Seleccione familia y proveedor para crear producto.
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="store-panel">
          <div className="store-tab-container">
            {tabs.map((e, i) => {
              return (
                <div
                  className={`store-tab ${
                    selectedTab === i ? "store-tab-selected" : ""
                  }`}
                  onClick={() => {
                    if (i !== selectedTab) {
                      setLimit(LIMIT);
                      setSelectedTab(i);
                      setInputSupplier("");
                      setCurrentSupplier(supplierStructure);
                      setSelectedBrandList([]);
                      setInputProduct("");
                      setPositiveStock(true);
                      setDiscontinued(false);
                      setStartDate("");
                      setEndDate("");
                    }
                  }}
                  key={i}
                >
                  <img src={e.icon} alt="img" />
                  {e.label}
                </div>
              );
            })}
          </div>
          <div className="store-body">
            {selectedTab !== "" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  justifyContent: "flex-end",
                  padding: "0 10px 10px 0",
                }}
              >
                <button
                  className="cell-label"
                  onClick={clearSupplierAndBrands}
                  tabIndex={-1}
                >
                  Limpiar todo
                </button>
              </div>
            )}
            <div className="store-body-cols">
              <div className="store-body-sec">
                <div className="opt-table-title">Búsqueda de proveedores</div>
                <div className="data-field">
                  <span className="label">Proveedor</span>
                  <InputIconSearchPanel
                    size={0}
                    tabIndex={2}
                    type={"type-alphanum-ext"}
                    options={supplierListFiltered}
                    input={inputSupplier}
                    inactive={selectedTab === ""}
                    onChange={(e) => {
                      setInputSupplier(e);
                    }}
                    onClear={() => {
                      setInputSupplier("");
                    }}
                    onSelect={async (e) => {
                      setInputSupplier("");
                      setCurrentSupplier(e);
                      checkSelectedBrands();
                    }}
                  ></InputIconSearchPanel>
                </div>
                {currentSupplier.id !== -1 && (
                  <SupplierCardLite
                    supplier={currentSupplier}
                    onClose={clearSupplierAndBrands}
                  ></SupplierCardLite>
                )}
              </div>
              <div className="store-body-sec">
                <div className="opt-table-title">Búsqueda de marcas</div>
                <div className="data-field">
                  <span className="label">Marca</span>
                  <InputIconSearchPanelMultiSelection
                    size={0}
                    tabIndex={3}
                    type={"type-alphanum-ext"}
                    options={brandList}
                    inactive={selectedTab === ""}
                    selectedOptions={selectedBrandList}
                    onChange={(e) => {
                      setSelectedBrandList(e);
                    }}
                  ></InputIconSearchPanelMultiSelection>
                </div>
                {selectedBrandList.length > 0 && (
                  <span style={{ fontWeight: "500", fontSize: 13 }}>
                    Marcas seleccionadas: {selectedBrandList.length}
                  </span>
                )}
                <div className="tag-content">
                  {selectedBrandList.map((e, i) => {
                    return (
                      <Tag
                        text={e}
                        key={i}
                        tagId={i}
                        onClick={(e) => {
                          setSelectedBrandList((prevBrands) =>
                            prevBrands.filter((brand) => brand !== e),
                          );
                        }}
                      ></Tag>
                    );
                  })}
                </div>
              </div>
            </div>
            {selectedTab !== "" && (
              <div className="store-product-info">
                <div className="opt-table-title">Filtrar productos</div>
                <div className="store-product-filter">
                  <div className="data-field">
                    <span className="label">
                      Modelo/Color/Calibre/Material/...
                    </span>
                    <InputIconSearch
                      size={3}
                      tabIndex={4}
                      type={"type-alphanum-ext"}
                      input={inputProduct.toUpperCase()}
                      onChange={async (e) => {
                        setInputProduct(e);
                      }}
                      onClear={async () => {
                        setInputProduct("");
                      }}
                    ></InputIconSearch>
                  </div>
                  <div
                    className="data-field"
                    onClick={() => {
                      setPositiveStock(!positiveStock);
                    }}
                  >
                    <span className="label">Stock positivo</span>
                    <CheckBox
                      tabIndex={5}
                      active={positiveStock}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                  <div
                    className="data-field"
                    onClick={() => {
                      setDiscontinued(!discontinued);
                    }}
                  >
                    <span className="label">Descatalogados</span>
                    <CheckBox
                      tabIndex={6}
                      active={discontinued}
                      onClick={() => {}}
                    ></CheckBox>
                  </div>
                  <div className="store-product-buttons">
                    <div ref={menuRef} style={{ position: "relative" }}>
                      <ButtonIconV
                        text="Edición masiva"
                        icon={"/images/settings-blue.svg"}
                        onClick={() => {
                          props.openBulkEditPanel(
                            selectedTab,
                            selectedProductList.map((selectedProduct) => {
                              const updatedProduct = productList.find(
                                (product) => product.id === selectedProduct.id,
                              );
                              return updatedProduct
                                ? updatedProduct
                                : selectedProduct;
                            }),
                            () => {},
                          );
                        }}
                      ></ButtonIconV>
                    </div>
                    <ButtonIconV
                      text="Imprimir"
                      icon={"/images/print-blue.svg"}
                      onClick={() => {
                        setExportOrSendPopup(true);
                      }}
                    ></ButtonIconV>
                  </div>
                </div>
                <div className="store-product-filter">
                  <div className="data-field">
                    <span className="label">Última compra desde</span>
                    <input
                      type="date"
                      max="9999-12-31"
                      tabIndex={7}
                      className="input-field"
                      value={startDate}
                      style={{ width: "155px" }}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                      onBlur={(e) => {
                        validateDate(e, 0);
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                  <div className="data-field">
                    <span className="label">Última compra hasta</span>
                    <input
                      type="date"
                      max="9999-12-31"
                      tabIndex={8}
                      className="input-field"
                      value={endDate}
                      style={{ width: "155px" }}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                      onBlur={(e) => {
                        validateDate(e, 1);
                      }}
                      onKeyUp={(e) => inputOnEnter(e)}
                    ></input>
                  </div>
                </div>
                <div className="opt-table-title">
                  <div>
                    Listado de productos (
                    {formatValueUnit(productListFiltered.length)} de{" "}
                    <span style={{ color: "#41b3ff" }}>
                      {formatValueUnit(totalProds)}
                    </span>
                    )
                  </div>
                </div>
                {selectedTab !== "" && <div>{tabs[selectedTab].content}</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
